import { createAsyncThunk } from '@reduxjs/toolkit';
import { tuitionApi } from '~/apis/tuition';
import { CREATE_TUITION, GET_LIST_TUITION } from '~/utils/constants/actionType';
import { IBodyCreateTuition, IQueryGetTuitions } from '~/utils/interface/tuition';

export const getListTuitions = createAsyncThunk(
  GET_LIST_TUITION,
  async (payload: IQueryGetTuitions, { rejectWithValue }) => {
    try {
      const res = await tuitionApi.getListTuitions(payload);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createTuition = createAsyncThunk(
  CREATE_TUITION,
  async (payload: IBodyCreateTuition, { rejectWithValue }) => {
    try {
      const res = await tuitionApi.createTuition(payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
